<template>
  <v-card
    outlined
    class="px-6 pt-6 pb-3"
  >
    <div class="d-flex flex-row justify-space-between align-center pb-3 ">
      <label class="subtitle-1 d-block grey--text">{{ page_title  }}</label>
    </div>

    <v-expansion-panels>
      <draggable
        v-model="gameList"
        group="people"
        @start="drag=true"
        @end="drag=false"
        class="list-group"
      >
        <v-expansion-panel
          v-for="(game,i) in gameList"
          :key="i"
        >
          <v-expansion-panel-header disable-icon-rotate>{{ game.text }}
            <template v-slot:actions>
              <v-icon
                color="error"
                @click.stop="removeGame(game)"
              >
                mdi-close-circle
              </v-icon>
            </template>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <image-preview v-model="game.thumbnail" />
          </v-expansion-panel-content>
        </v-expansion-panel>
      </draggable>
    </v-expansion-panels>

    <v-dialog
      v-model="dialog"
      width="500"
    >
      <template v-slot:activator="{ on, attrs }">
        <b
          v-bind="attrs"
          v-on="on"
          class="text-caption font-weight-bold header-btns"
        >{{ add_item_text }}
        </b>
      </template>

      <v-card height="500">
        <v-card-title class="headline grey lighten-2">
          {{ dialog_title }}
        </v-card-title>

        <v-card-text class="mt-10">
          <v-autocomplete
            :label="dropdown_label"
            clearable
            outlined
            full-width
            :items="gamesAvailable"
            v-model="selectedGame"
          />
        </v-card-text>

        <v-card-actions class="mt-15">
          <v-spacer></v-spacer>
          <v-btn
            v-if="gamesAvailable.length > 0"
            color="primary"
            text
            @click="addSelectedGame"
            bottom
            right
            absolute
            class="mb-4"
          >
            add
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-card>
</template>
<script>
import ImagePreview from '@/components/ImagePreview'
import find from 'lodash/find'
import findIndex from 'lodash/findIndex'
import indexOf from 'lodash/indexOf'
import draggable from 'vuedraggable'
import map from 'lodash/map'

export default {
  props: {
    page_title: {
      type: String,
      default: 'Games Live'
    },
    add_item_text: {
      type: String,
      default: 'Add Game'
    },
    dialog_title: {
      type: String,
      default: 'Add a Live Game'
    },
    dropdown_label: {
      type: String,
      default: 'Live Games Available'
    },
    gamesAvailable: {
      type: Array,
      default () {
        return []
      }
    },
    games: {
      type: Array,
      default () {
        return []
      }
    },
    addItems: {
      type: Array,
      default () {
        return []
      }
    },
    removeItems: {
      type: Array,
      default () {
        return []
      }
    },
    liveItemsOrg: {
      type: Array,
      default () {
        return []
      }
    }
  },
  components: {
    ImagePreview,
    draggable
  },

  data () {
    return {
      selectedGame: null,
      dialog: false,
      gameList: []
    }
  },
  methods: {
    removeGame (game) {
      const existsOrgData = find(this.liveItemsOrg, ['value', game.value])
      if (game.isLiveItem === true || existsOrgData) {
        this.removeItems.push(game.value)
      }

      let itemIndex = findIndex(this.games, ['value', game.value])
      this.games.splice(itemIndex, 1)

      let addItemIndex = indexOf(this.addItems, game.value)
      this.addItems.splice(addItemIndex, 1)
    },
    addSelectedGame () {
      let id = this.selectedGame
      const game = find(this.gamesAvailable, ['value', id])
      const exists = find(this.games, ['value', id])
      const existsOrgData = find(this.liveItemsOrg, ['value', id])

      if (!exists && id && !existsOrgData) {
        this.addItems.push(id)
        this.games.push(game)

        let remItemIndex = indexOf(this.removeItems, id)

        if (remItemIndex !== -1) this.removeItems.splice(remItemIndex, 1)
      }

      this.dialog = false
    }
  },
  watch: {
    games: {
      immediate: true,
      handler (val) {
        this.gameList = val
      }
    },
    gameList: {
      immediate: true,
      handler (val) {
        let itemOrder = map(val, 'value')
        this.$emit('update:itemOrder', itemOrder)
      }
    }
  }
}
</script>

<style Scoped>
.header-btns {
  color: #df4661;
  cursor: pointer;
}
.list-group {
  width: 100%;
}
</style>
